import styled from 'styled-components';
import { Tabs, Tab } from '@mui/material';

import colors from '../../styles/colors';

const StyledTabs = styled(Tabs)`
  &.MuiTabs-root {
    border-radius: 5px;
    background-color: ${colors.base.secondary3};
    min-height: 38px;
    height: fit-content;
  }

  & .MuiTabs-flexContainer {
    justify-content: space-evenly;
    align-items: center;
  }

  .MuiTabs-indicator {
    display: none;
  }
`;

const StyledTab = styled(Tab)`
  &.MuiTab-root {
    flex:1;
    color: ${colors.base.beta};
    background-color: ${colors.base.secondary3};
    min-height: 30px;
    height: fit-content;
    text-transform: none;
    flex-direction: row;
    align-items: center;
    margin: 4px;
    padding: 0;
  }

  &:not(:first-child) {
    margin-left: 8px;
  }

  & > *:first-child {
    margin-bottom: 0;
  }

  &.Mui-selected {
    color: ${colors.base.alpha} !important;
    background-color: ${colors.base.secondary2};
    margin: 4px;
    border-radius: 5px;
    min-height: 30px;
    font-weight: 200;

    &::before {
      content: '';
    }
  }
`;

const StyledCount = styled.span`
  background-color: ${colors.base.alpha};
  color: ${colors.base.beta};
  width: 20px;
  height: 20px;
  align-content: center;
  border-radius: 50%;
  margin-left: 5px;
  font-size: 12px;
  font-weight: 500;
`;

export {
  StyledTabs,
  StyledTab,
  StyledCount,
};
